import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";

// Satoshi is self-hosted via @font-face in public/fonts.css (#117) —
// bundling font CSS base64-inlined the woff2 into the CSS bundle.
import "./styles.css";
import { router } from "./router";

declare const __SENTRY_DSN__: string | undefined;

// In production, build.ts injects <link href="/fonts.css"> into the built
// index.html (a static link in the source html would make Bun's bundler
// inline the woff2). The dev server has no such post-build step, so inject
// it at runtime here; dead-code-eliminated from the production bundle.
if (process.env.NODE_ENV !== "production") {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "/fonts.css";
  document.head.append(link);
}

if (typeof __SENTRY_DSN__ !== "undefined" && __SENTRY_DSN__) {
  Sentry.init({
    dsn: __SENTRY_DSN__,
    environment: "web",
    // Session Replay. We do NOT passively record the whole public site:
    // replaysSessionSampleRate is 0, so Replay runs in error-buffer mode
    // everywhere. Full-session recording is switched on only for the
    // inquiry funnel (see InquiryReplayBoundary) — that is where the
    // "do clients complete the configurator unaided" question lives.
    // maskAllText/blockAllMedia stay on (the default) so PII the client
    // types into the form is never sent to Sentry.
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
